<template>
  <v-container>
    <v-row class="text-center">
      <v-col cols="12" id="chart">
        <h1>{{ naming }}</h1>
        <apexchart
          v-if="chartOptions"
          ref="cardChart"
          type="pie"
          height="380"
          :options="chartOptions"
          :series="series"
        />
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-dialog
        v-model="dialog"
        max-width="500"
      >
        <v-card class="border">
          <v-card-title class="text-h5">Statistics</v-card-title>
          <v-card-text>
            Element that you clicked: {{ chartDialog }}
          </v-card-text>
          <v-row>
            <v-col cols="12" lg="12" md="12">
              <Bar />
            </v-col>
          </v-row>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="teal" text @click="dialog = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
import Bar from "../components/Bar.vue";
import axios from "axios";

export default {
  components: {
    Bar,
  },
  props: {
    naming: String,
  },
  data() {
    return {
      dialog: false,
      chartDialog: 0,
      series: [0, 0, 0],
    };
  },
  mounted() {
    this.getAvailableCards();
  },
  methods: {
    async getAvailableCards() {
      try {
        const response = await axios.post(
          this.$apiUrl,
          {
            query: `query{
              cardsByStatuses{
                ALL
                NEW
                USED
                INVALID
              }
            }`,
          },
          {
            headers: {
              Authorization: "Bearer " + (await this.$auth.getAccessToken()),
            },
          }
        );

        const res = response.data.data.cardsByStatuses;
        this.series = [res.NEW || 0, res.USED || 0, res.INVALID || 0];

        // update chart explicitly if needed
        this.$nextTick(() => {
          if (this.$refs.chart) {
            this.$refs.chart.updateSeries(this.series);
          }
        });
      } catch (error) {
        console.error("Failed to fetch card data:", error);
      }
    },

    onDataPointSelected(event, chartContext, config) {
      // sum all series values
      const sum = config.w.globals.series.reduce((acc, val) => acc + val, 0);
      const value = config.w.globals.series[config.dataPointIndex];
      const percent = ((value / sum) * 100).toFixed(2);

      this.chartDialog = `${percent}% (${value})`;
      this.dialog = true;
    },
  },
  computed: {
    chartOptions() {
      return {
        chart: {
          width: 380,
          type: "pie",
          events: {
            dataPointSelection: this.onDataPointSelected, // <-- normal function, bound to Vue
          },
        },
        legend: {
          formatter: (val, opts) => {
            return val + " - " + opts.w.globals.series[opts.seriesIndex];
          },
          labels: {
            useSeriesColors: true,
          },
          position: "bottom",
        },
        labels: ["New", "Used", "Invalid"],
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 320,
              },
              legend: {
                position: "bottom",
              },
            },
          },
        ],
      };
    },
  },
};
</script>

<style scoped>
.border {
  border: 1px solid #009688;
}
</style>
